module.exports = __webpack_public_path__ + "media/images/athletes/3389-f5ae3f0a8586938b75cad34bef26fbe2.png";